<section class="faq-wrap">
  <div class="wrap-lg">
    <div class="faq-inner">
      <div class="nav-sec">
        <div class="back-nav" (click)="goTohome()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 6L9 12L15 18" stroke="#1A204B" stroke-width="1.75" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <span class="nav-name" >Back</span>
        </div>
      </div>
      <div class="page-head">
        <div class="head-left">
          <div class="page-title">Frequently Asked Questions</div>
        </div>
      </div>
      <div class="faq-content">
        <div class="acc-item" *ngFor="let data of allFaqData">
          <div class="acc-head"   (click)="showFaq(data.id, $event)">{{data.content}}</div>
          <div id={{data.id}} class="acc-content">{{data.replies[0].content}}</div>
        </div>
        <!-- <div class="acc-item">
          <div class="acc-head" (click)="showFaq('faq_2', $event)">Sample Question about Loans against Property?</div>
          <div id="faq_2" class="acc-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur faucibus gravida urna, ut venenatis ante. Proin quis viverra arcu, non faucibus sapien. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur faucibus gravida urna, ut venenatis ante. Proin quis viverra arcu, non faucibus sapien. </div>
        </div>
        <div class="acc-item">
          <div class="acc-head" (click)="showFaq('faq_3', $event)">Sample Question about Loans against Property?</div>
          <div id="faq_3" class="acc-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur faucibus gravida urna, ut venenatis ante. Proin quis viverra arcu, non faucibus sapien. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur faucibus gravida urna, ut venenatis ante. Proin quis viverra arcu, non faucibus sapien. </div>
        </div> -->
      </div>
    </div>
  </div>
</section>
